export const PARTNER_CURATED_LISTS = 'OutofMilkCuratedList'
export const PARTNER_BONIAL_FR = 'BonialFr'
export const PARTNER_KAUFDA_DE = 'KaufDADe'
export const PARTNER_A_BEAUTIFUL_PLATE = 'ABeautifulPlate'
export const PARTNER_ADD_A_PINCH = 'AddAPinch'
export const PARTNER_ASHLEE_MARIE = 'AshleeMarie'
export const PARTNER_ASIAN_CAUCASIAN = 'AsianCaucasian'
export const PARTNER_EAT_WHAT_TONIGHT = 'EatWhatTonight'
export const PARTNER_FEASTING_AT_HOME = 'FeastingAtHome'
export const PARTNER_FOOD_FAITH_FITNESS = 'FoodFaithFitness'
export const PARTNER_I_AM_A_FOOD_BLOG = 'IAmAFoodBlog'
export const PARTNER_KEVIN_IS_COOKING = 'KevinIsCooking'
export const PARTNER_LIFE_LOVE_AND_SUGAR = 'LifeLoveAndSugar'
export const PARTNER_MEXICO_IN_MY_KITCHEN = 'MexicoInMyKitchen'
export const PARTNER_PANNING_THE_GLOBE = 'PanningTheGlobe'
export const PARTNER_PURELLA = 'Purella'
export const PARTNER_THE_FULL_HELPING = 'TheFullHelping'
export const PARTNER_THE_KITCHEN_PAPER = 'TheKitchenPaper'
export const PARTNER_FAV_FAMILY_RECIPES = 'FavFamilyRecipes'
export const PARTNER_750G = '750G'
export const PARTNER_MARMITON = 'Marmiton'
